<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="Total Penalties Payed" :help="help1" :secondline="$options.filters.toCurrency(totalPenaltiesUSD, 0, 'USD')" color="#07D3DA">{{ totalPenalties | toInt(0, "WISE")}}</NumberCard>
      </v-col>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="Average Penalty per Day" :help="help2" :secondline="$options.filters.toCurrency(avgPenaltiesPerDayUSD, 0, 'USD')" color="#C6362F">{{ avgPenaltiesPerDay | toInt(0, "WISE")}}</NumberCard>
      </v-col>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="APY from Penalties" :help="help3" color="#BDD358">{{ additionalApy | toInt(3, "%")}}</NumberCard>
      </v-col>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="Highest Paid Single Penalty" :secondline="$options.filters.toCurrency(highestSinglePenaltyUSD, 0, 'USD')" :help="help4" color="#E28413">{{ highestSinglePenalty | toInt(0, "WISE")}}</NumberCard>
      </v-col>
    </v-row>

    <v-row class="">
      <v-col cols="12" md="12" lg="12">
          <Penalties />
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import Penalties from "@/components/Penalties.vue";
  import NumberCard from "@/components/widgets/NumberCard.vue";

  import {
    mapState
  } from 'vuex';

  export default {
    name: "PenaltyView",
    components: {
      Penalties,
      NumberCard
    },
    data() {
      return {
        totalPenalties: 0,
        stakingDays: 0,
        additionalApy: 0,
        highestSinglePenalty: 0,
        value3: 0,
        value4: 0,
        currentPriceUSD: 0,
        totalPenaltiesUSD: 0,
        secondline2: 0,
        help1: "Total Penalties payed to stakers since beginning",
        help2: "",
        help3: "How much of the APY on the stakes result from penalties instead of from inflation",
        help4: "Biggest penalty until now from a single stake",
      }
    },
    computed: {
      avgPenaltiesPerDay() {
        return this.totalPenalties / this.stakingDays;
      },
      avgPenaltiesPerDayUSD() {
        return this.avgPenaltiesPerDay * this.currentPriceUSD;
      },
      highestSinglePenaltyUSD() {
        return this.highestSinglePenalty * this.currentPriceUSD;
      },
      ...mapState({
        currentWiseDay: state => state.currentWiseDay,
        stakeStats: state => state.stakeStats,
        currentETHPrice: state => state.currentETHPrice,
        currentUniswapStats: state => state.currentUniswapStats,
        totalStaked: state => state.totalStaked,
      }),
    },
    mounted() {
      this.updateStakingDays();
      this.updatePrice();
      this.updateAllCards();
    },
    methods: {
      updateStakingDays() {
        if(this.$store.state.currentWiseDay > 0) {
          this.stakingDays = this.$store.state.currentWiseDay - 51;
        }
      },
      updatePrice() {
        this.currentPriceUSD = this.$store.state.currentUniswapStats.priceETH * this.$store.state.currentETHPrice
      },
      updateAllCards() {
        this.updateCard1();
        this.updateCard3();
        this.updateCard4();
      },
      isDataFetchedCard1() {
        return (
          this.$store.state.stakeStats.totalPaiedPenalties > 0 &&
          this.$store.state.currentUniswapStats.priceETH > 0 &&
          this.$store.state.currentETHPrice > 0
        )
      },
      isDataFetchedCard2() {
        return (
          this.$store.state.currentWiseDay > -1
        )
      },
      isDataFetchedCard3() {
        return (
          this.$store.state.currentWiseDay > -1
        )
      },
      isDataFetchedCard4() {
        return (
          this.$store.state.currentWiseDay > -1
        )
      },
      updateCard1() {
        if (this.isDataFetchedCard1()) {
          this.totalPenalties = this.$store.state.stakeStats.totalPaiedPenalties;
          this.totalPenaltiesUSD = this.totalPenalties * this.currentPriceUSD;
        }
      },
      updateCard3() {
        if (this.isDataFetchedCard3()) {
          this.additionalApy = this.avgPenaltiesPerDay / this.$store.state.totalStaked * 365 * 100;
        }
      },
      updateCard4() {
        if (this.isDataFetchedCard4()) {
          this.highestSinglePenalty = parseFloat(this.$store.state.stakeStats.highestSinglePenalty);
        }
      },
    },
    watch: {
      currentWiseDay() {
        this.updateStakingDays();
      },
      stakeStats() {
        this.updateCard1();
        this.updateCard4();
      },
      currentETHPrice() {
        this.updatePrice();
        this.updateCard1();
      },
      currentUniswapStats() {
        this.updatePrice();
        this.updateCard1();
      },
      totalStaked() {
        this.updateCard3();
      },
    }
  }
</script>

<style lang="css" scoped>
</style>
